import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-triangle\">\n    <path fill-rule=\"evenodd\" d=\"M11.000,7.999 L5.471,0.798 L-0.000,7.999 L11.000,7.999 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol